'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './adminBaskets.routes';
import { ModalBase } from '../../shared/modal.base';
import { AdminBasketUtil, Filter } from './adminBasketUtil';
import { ISeason, ISeasonUtilsService, IBasket, IOptionsService } from '../../interfaces';
import { SortingBase } from '../../shared/sorting.base';

export class AdminBasketsComponent extends ModalBase {
  $http: ng.IHttpService;
  $state: ng.ui.IStateService;
  $stateParams: any;
  OptionsService: IOptionsService;
  SeasonUtils: ISeasonUtilsService;
  AdminBasketUtil: AdminBasketUtil = new AdminBasketUtil();

  membership: any;
  baskets: any[];

  seasons: ISeason[];
  selectedSeason: ISeason;
  
  filters: Filter[] = [];
  selectedFilter: Filter;

  filteredBaskets_L1: any[];
  filteredBaskets_L2: any[];
  filter: string = '';

  showPaymentAlert: boolean;
  showCalculatePriceAlert: boolean;

  // Sorting variables
  sorting: SortingBase = new SortingBase();
  // sortBy: string;
  // sortAsc: boolean;
  // sortDesc: boolean;


  /*@ngInject*/
  constructor($http, $state, $stateParams, OptionsService, $uibModal, Season) {
    super($uibModal);
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.OptionsService = OptionsService;

    // Sorting by default by creation date
    this.sorting.changeSortBy('creationDate');

    // Building the filter options
    this.buildFilters();

    let scope = this;
    scope.applySeason(Season, () => {
      scope.loadingBaskets( () => {
        scope.applyFilters();
      });
    });
  }

  buildFilters() {
    this.filters.push(new Filter(0, 'ALL baskets'));
    this.filters.push(new Filter(6, 'Deadline approaching'));
    this.filters.push(new Filter(2, 'Disables'));
    this.filters.push(new Filter(1, 'Enables'));
    this.filters.push(new Filter(3, 'In payment'));
    this.filters.push(new Filter(4, 'Nothing paid'));
    this.filters.push(new Filter(5, 'Totatlly paid'));
    // this.filters.push(new Filter(7, 'To calculate basket price'));
  }

  private applySeason(Season, callback) {
    let scope = this;

    Season.query(seasons => {
      scope.seasons = seasons;

      // When there is a season selected
      if (_.has(scope.$stateParams, 'seasonId')) {
        scope.selectedSeason = _.find(scope.seasons, season => {
          return season._id+'' === scope.$stateParams.seasonId+'';
        });
        if (scope.selectedSeason) {
          return callback();
        }
      }

      // When there is not a season selected or passed by parameters
      scope.OptionsService.getActiveSeason()
      .then(activeSeason => {
        if (!activeSeason) {
          let latestSeason = scope.seasons[scope.seasons.length-1];
          scope.$state.go('adminBaskets', {seasonId: latestSeason._id, filterId: 0});
          return;
        }
        scope.$state.go('adminBaskets', {seasonId: activeSeason._id, filterId: 0});
      });
    });
  }

  getResolve(basket, payment) {
    let scope = this;
    return {
      basket: function () {
        return basket;
      },
      payment: function () {
        return payment;
      },
      season: function () {
        return scope.selectedSeason
      },
      filteredBaskets: function () {
        return scope.filteredBaskets_L2;
      }
    }
  }

  loadingBaskets(callback){
    let scope = this;

    scope.$http.get("/api/baskets/bySeason/"+scope.selectedSeason._id)
    .then(res => {
      scope.baskets = res.data as IBasket[];

      _.each(scope.baskets, basket => {
        //parsing extras of every baskets
        this.AdminBasketUtil.parseExtraToModelView(basket, this.selectedSeason);
  
        //Calculate Extras price
        (basket as any).$totalExtras = this.AdminBasketUtil.getTotalExtras(basket);

        // Get the new price model
        if (basket.newPrice) { 
          this.selectedSeason.prices.some(price => {
              if ( price._id === basket.newPrice ) {
                  basket.newPrice = price;
                  return true;    
              }
          });
        }

        // Calculate Total price
        (basket as any).$total = 0
        if (basket.price !== null) {
          (basket as any).$total = basket.price + basket.$totalExtras;
        } else if (basket.newPrice) {
          (basket as any).$total = basket.newPrice.price + basket.$totalExtras;
        }
        
        // Calculate Debt price
        (basket as any).$debt = basket.$total - this.AdminBasketUtil.getTotalPayment(basket);

        //Select option for send emails
        basket.$selected = false;

        // fill in creation date for old baskets without this date
        if (!basket.creationDate) {
          basket.creationDate = '';
        }
      });
      
      callback();
    });
  }

  applyFilters() {
    //filtering list of baskets
    if (_.has(this.$stateParams, 'filterId')) {
      this.selectedFilter = this.filters.find(f => f.id == this.$stateParams.filterId);
      this.filtering();
    }
  }

  filtering() {
    this.showPaymentAlert = false;
    this.showCalculatePriceAlert = false;
    

    if (this.selectedFilter) {
      if (this.selectedFilter.id == 0) {
        this.filteredBaskets_L1 = this.baskets;
      } else if (this.selectedFilter.id == 1) {
        this.filteredBaskets_L1 = this.baskets.filter(b => b.enable);
      } else if (this.selectedFilter.id == 2) {
        this.filteredBaskets_L1 = this.baskets.filter(b => !b.enable);
      } else if (this.selectedFilter.id == 3) {
        this.filteredBaskets_L1 = this.baskets.filter(b => b.$total>b.$debt && b.$debt>0);
      } else if (this.selectedFilter.id == 4) {
        this.filteredBaskets_L1 = this.baskets.filter(b => b.$total == b.$debt);
      } else if (this.selectedFilter.id == 5) {
        this.filteredBaskets_L1 = this.baskets.filter(b => b.$debt <= 0);
      } else if (this.selectedFilter.id == 6) {
        this.filteredBaskets_L1 = this.baskets.filter(b => this.filterDeadlinePayments(b.payments));
      } 
    }

    this.updateFilter();
  }

  updateFilter() {
    let scope = this;
    let filter = scope.filter.toLowerCase();
    this.filteredBaskets_L2 = _.filter(this.filteredBaskets_L1, basket=> {
      let candidate = (basket.membership.firstName +
                      basket.membership.lastName +
                      basket.membership.firstName).toLowerCase();

      return candidate.indexOf(filter) >= 0;
    });

    this.filteredBaskets_L2 = _.sortBy(this.filteredBaskets_L2, (basket) => {
      return (basket as IBasket).membership.lastName +
             (basket as IBasket).membership.firstName;
    });
  }

  filterDeadlinePayments(payments) {
    let deadline: boolean = false;

    for (let pay of payments) {
      if (this.isDeadlinePaymentApproaching(pay)) {
        deadline = true;
        break;
      }
    }
    return deadline;
  }

  isDeadlinePaymentApproaching(payment) {
    let approching = false;

    if (payment.amount <= 0) {
      let currentTime = (new Date()).getTime()

      let paymentTime = (new Date(payment.date)).getTime();
      let paymentTimeDeadline = paymentTime - 24*60*60*1000*7;
      
      if (currentTime > paymentTimeDeadline && currentTime <= paymentTime) {
        approching = true;
        this.showPaymentAlert = true;
      }
    }
    return approching;
  }

  selectSeason(season) {
    this.$state.go('adminBaskets', {seasonId: season._id, filterId: this.selectedFilter.id});
  }

  selectFilter(filter) {
    this.$state.go('adminBaskets', {seasonId: this.selectedSeason._id, filterId: filter.id});
  }

  selectAllBasket(event) {
    for (let basket of this.filteredBaskets_L2) {
      (basket as any).$selected = event.target.checked;
    }
  }

  activateBasketChange(basket){
    basket.enable = !basket.enable;
    let candidate = this.cloneBasket(basket);
    
    this.AdminBasketUtil.parseExtraToData(candidate);
    this.$http.put("/api/baskets/activate/"+basket._id, candidate);
  }

  createBasket() {
    let scope = this;
    this.modal('adminBasketEdit', this.getResolve(null, null), () => {
      scope.loadingBaskets( () => {
        scope.applyFilters();
      });
    });
  }

  editBasket(basket) {
    let scope = this;
    let candidate = this.cloneBasket(basket);

    this.modal('adminBasketEdit', this.getResolve(candidate, null), () => {
      scope.loadingBaskets(() => {
        scope.applyFilters();
      });
    });
  }

  private cloneBasket(basket) {
    let candidate = _.cloneDeep(basket);
    delete candidate.$totalExtras;
    delete candidate.$total;
    delete candidate.$debt;
    delete candidate.$selected;
    return candidate;
  }

  deleteBasket(basket) {
    let scope = this;
    let candidate = this.cloneBasket(basket);

    this.modal('adminBasketDelete', this.getResolve(candidate, null), basketToRemove => {
      this.$http.delete('/api/baskets/' + basketToRemove._id)
      .then(basket => {
        scope.baskets.splice(scope.baskets.indexOf(basket), 1);
        
        scope.loadingBaskets(() => {
          scope.applyFilters();
        });
      });
    });
  }

  payment(basket, payment) {
    let scope = this;
    let basketCandidate = _.cloneDeep(basket); //Not delete the private attributes $debt, $totalExtras and $total
    delete basketCandidate.$selected;

    let paymentCandidate = _.cloneDeep(payment);

    //Basket is passing with privates fields. So adminBasketPayment has to delete these private fields
    this.modal('adminBasketPayment', this.getResolve(basketCandidate, paymentCandidate), (newBasket) => {
      basket.payments = newBasket.payments;
      
      //Recalculate DEBT because of payment process
      basket.$debt = basket.$total - this.AdminBasketUtil.getTotalPayment(basket);
      
      scope.filtering();
    });
  }

  deletePayment(basket, payment) {
    let scope = this;
    let basketCandidate = this.cloneBasket(basket);
    let paymentCandidate = _.cloneDeep(payment);

    this.modal('adminBasketDelete', this.getResolve(basketCandidate, paymentCandidate), (paymentToRemove) => {
      if (paymentToRemove && paymentToRemove!=null) {
        basketCandidate.payments = basketCandidate.payments.filter(p => p._id != paymentToRemove._id);

        this.$http.put('/api/baskets/'+ basketCandidate._id, basketCandidate)
        .then(res => {
          basket.payments = (res.data as any).payments;
          scope.filtering();
        });
      }
    });
  }

  messages() {
    let scope = this;

    this.modal('adminBasketsMessages', this.getResolve(null, null), () => {
      scope.loadingBaskets(() => {
        scope.applyFilters();
      });
    });
  }
   sortByName() {
    this.sorting.changeSortBy('membership.lastName');
    this.sorting.changeSortDirection();
  }

  /**
   * Sorting by membership creation date
   */
   sortByDate() {
    this.sorting.changeSortBy('creationDate');
    this.sorting.changeSortDirection();
  }

  exportEmails() {
    let scope = this;
    
    this.modal('adminBasketExportEmails', this.getResolve(null, null), () => {
      scope.loadingBaskets( () => {
        scope.applyFilters();
      });
    });
  }
  
  getMemberReference(basket) {
    let reference = '';
    if (basket.memberReferenceName) {
      reference = ': ' + basket.memberReferenceName;
    }
    return reference;
  }
}

export default angular.module('terrappApp.adminBaskets', [uiRouter])
  .config(routes)
  .component('adminBaskets', {
    template: require('./adminBaskets.html'),
    controller: AdminBasketsComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBaskets.component.ts